import { isEmptyData, cleanText } from '../../../utils/helper';
import { PickupIcon } from '../../../utils/svg';

const OutletDetail = ({ values = {} }) => {
  if (!values?.orderType) return null;
  const address = [values?.origin?.address, !isEmptyData(values?.origin?.floor) ? `Lantai ${values?.origin?.floor}` : null, !isEmptyData(values?.origin?.unit) ? `Unit ${values?.origin?.unit}` : null].filter(Boolean).join(', ');
  const orderType = cleanText(values?.orderType);
  return (
    <div className={`bg-white p-4 gap-1 flex flex-col border-b-8 border-solid border-gray-100 ${orderType === 'delivery' || orderType === 'dinein' ? 'hidden' : ''}`}>
      <div className='text-xs font-semibold text-gray-700'>Store Location</div>
      <div className='text-sm font-semibold text-gray-800'>{values?.origin?.name ?? ''}</div>
      <div className='text-xs font-normal text-gray-700'>{address}</div>
      <div className='border-t-1 border-solid mt-4 pt-4 border-gray-200 flex items-center gap-2'>
        <PickupIcon className={'w-8 h-8'} />
        <div className='text-gray-700 font-semibold text-sm'>Pick up in 10 mins</div>
      </div>
    </div>
  );
};

export default OutletDetail;
